import { CInput } from '@app/components/Common';
import { COLORS } from '@app/constants';
import { USERINFO } from '@app/constants/APIKEYS';
import { useToken } from '@app/hooks';
import { useMyProfile } from '@app/hooks/user/myprofile';
import { MButton } from '@app/mobile/components';
import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { MText, MView } from '@/styles/mobilePageStyles';
import { ThemeContext } from '@/theme/ThemeProvider';
import API from '@utils/api';
import { apiError } from '@utils/ExpensiveFunction';
import { Button, message } from 'antd';

const ChangeUsername = () => {
  const { theme } = useContext(ThemeContext);
  const [username, setUsername] = useState('');
  const { t } = useTranslation();
  const { mutate } = useMyProfile();
  const { data: token } = useToken();
  const modifyUsername = async () => {
    if (username?.length >= 2 && username?.length <= 20) {
      const res = await API.put(USERINFO, token + '', {
        nickname: username,
      });

      if (res?.result?.success) {
        message.success(t('usernameChangeSuccess') + '');
        mutate();
      } else {
        const errorResult = apiError(t, res?.result?.msgcode);
        message.error(t('invalidError') + ' ' + errorResult);
      }
    } else {
      message.error(t('nicknameLengthLimit') + '');
    }
  };
  return (
    <MView
      style={{
        width: '100%',
      }}
    >
      <MText
        style={{
          fontSize: 14,
          fontWeight: '300',
        }}
      >
        {t('username')}
      </MText>

      <MView
        style={{
          width: '100%',
          flexDirection: 'row',
          justifyContent: 'space-between',
          height: '40px',
          gap: 6,
        }}
      >
        <CInput
          placeholder={t('enterUsername')}
          value={username}
          type={'text'}
          maxLength={20}
          onChange={(e: any) => setUsername(e.target.value)}
          vStyle={{
            width: '100%',
            height: '100%',
          }}
          style={{
            background: theme.COLORS.PrimaryInputBg,
            border: `1px solid ${theme.COLORS.PrimaryInputBorder}`,
            color: theme.COLORS.textw,
            padding: `8px 12px`,
            width: '100%',
            height: '100%',
            margin: 0,
            borderRadius: 4,
          }}
        />
        <Button
          onClick={modifyUsername}
          style={{
            background: COLORS.primary,
            borderRadius: 4,
            width: '80px',
            height: '100%',
            color: COLORS.white,
          }}
        >
          {t('save')}
        </Button>
      </MView>

      <MText style={{ fontSize: 11, color: COLORS.lightGray4, marginTop: 4 }}>
        {t('changeUsernameGuide')}
      </MText>
    </MView>
  );
};

export default ChangeUsername;
